import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const HelpRequest = createApi({
    reducerPath: "helpRequestApi",
    baseQuery: encryptedBaseQueryWithReauth(),
    tagTypes: ["getHelpRequest", "getHelpRequestPackage", "getHelpRequestList"],
    endpoints: (builder) => ({
        getHelpRequestList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getHelpRequestList"],
        }),
    getTeacherList: builder.query({
            query: () => `/exams/v1/help/teacher/list`,
            providesTags: ["getTeacherList"],
        }),
        assignHelpRequest: builder.mutation({
            query: ({ uid, assignedUids, type, doubtId }) => ({
                url: `/exams/v1/help/assign/${uid}`,
                method: "PATCH",
                body: { assignedUids, type, doubtId },
            }),
            invalidatesTags: ["getHelpRequestList"],
        }),

        markHelpRequestDone: builder.mutation({
            query: ({ uid, type, doubtId }) => ({
                url: `/exams/v1/help/mark/done/${uid}`,
                method: "PATCH",
                body: { type, doubtId },
            }),
            invalidatesTags: ["getHelpRequestList"],
        }),
    }),
});

export const {
    useGetHelpRequestListQuery,
    useGetTeacherListQuery,
    useAssignHelpRequestMutation,
    useMarkHelpRequestDoneMutation,
} = HelpRequest;
